import { gql } from '@apollo/client';

export const getDataForTransformationsQuery = gql`
  query GetDataForTransformations {
    cities(filter: { scope: ALL }) {
      id
      name
      slug
    }
    locations(filter: { scope: ALL }, limit: 500) {
      id
      name
      fullName
      locationGroupId
      slug
    }
    categories {
      id
      name
      pluralName
      slug
      children {
        id
        name
        pluralName
        slug
      }
    }
    rooms @client {
      id
      slug
      name
    }
    type @client {
      id
      name
    }
    sort @client {
      id
      params
      name
    }
  }
`;

export const getSortDataForTransformationsQuery = gql`
  query GetSortDataForTransformations {
    sort @client {
      id
      params
      name
    }
  }
`;

export const getFilterVariantsForVipPage = gql`
  query GetFilterVariantsForVipPage {
    cities(filter: { scope: ALL }) {
      id
      name
      slug
    }
    categories {
      id
      name
      slug
      children {
        id
        name
        slug
      }
    }
    type @client {
      id
      name
    }
  }
`;

export const getLocalDataQuery = gql`
  query LocalData($id: ID!) {
    city(id: $id) {
      id
      name
      slug
      locations {
        id
        name
        slug
      }
    }
    categories @client {
      id
      name
      pluralName
      slug
      children {
        id
        name
        pluralName
        slug
      }
    }
    rooms @client {
      id
      slug
    }
    sort @client {
      id
      params
      name
    }
  }
`;
